<div>
  <tab-bar [ngClass]="{'exp-lib-admin-tab': true }" [tabs]="tabs" [(currentTabId)]="currentTabId" (currentTabIdChange)="onTabChange($event)" [experienceLibraryAdminTabs]="true"></tab-bar>
  @if (isIndustryTabDisplayed) {
    <div>
      <div>
        <rn-industry-list></rn-industry-list>
      </div>
    </div>
  }
  @if (isCompanyTypeTabDisplayed) {
    <div>
      <div>
        <rn-company-type-list></rn-company-type-list>
      </div>
    </div>
  }
  @if (isOutcomeTabDisplayed) {
    <div>
      <div>
        <rn-outcome-list></rn-outcome-list>
      </div>
    </div>
  }
  @if (isExperienceTypeTabDisplayed) {
    <div>
      <div>
        <rn-experience-type-list></rn-experience-type-list>
      </div>
    </div>
  }
</div>